export enum ReportErrorType {
  GENERIC = 'GENERIC',
  MIN_SAMPLE_REQUIRED = 'MIN_SAMPLE_REQUIRED',
}
